import React from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "@/context/LanguageContext";

export const PricingFAQ = () => {
  const { t } = useTranslation();

  const faqs = [
    { q: t("pricingFaq.q1"), a: t("pricingFaq.a1") },
    { q: t("pricingFaq.q2"), a: t("pricingFaq.a2") },
    {
      q: t("pricingFaq.q3"),
      a: (
        <>
          {t("pricingFaq.a3")}{" "}
          <Link to="/limits" className="inline-flex items-center text-primary font-medium hover:underline">
            {t("pricingFaq.viewLimits")}
          </Link>
        </>
      ),
    },
    { q: t("pricingFaq.q4"), a: t("pricingFaq.a4") },
    { q: t("pricingFaq.q5"), a: t("pricingFaq.a5") },
    { q: t("pricingFaq.q6"), a: t("pricingFaq.a6") },
    { q: t("pricingFaq.q7"), a: t("pricingFaq.a7") },
  ];

  return (
    <div className="flex flex-col py-12">
      <h1 className="hidden text-center text-2xl font-normal lg:block">{t("pricingFaq.title")}</h1>
      <h1 className="block text-center text-2xl font-normal lg:hidden">{t("pricingFaq.titleShort")}</h1>
      <span className="mb-10 mt-4 text-center text-muted-foreground lg:mb-12">
        {t("pricingFaq.contactPrompt")} &nbsp;
        <a
          className="underline decoration-primary/50 text-foreground hover:text-primary hover:decoration-primary transition-all duration-300 underline-offset-4"
          href="mailto:hello@shattaraai.com"
        >
          {t("pricingFaq.contactUs")}
        </a>
      </span>

      <div className="container mx-auto max-w-[900px] px-4">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border-b -mt-2 mb-3 font-normal leading-loose opacity-90"
            >
              <AccordionTrigger className="flex flex-1 items-center justify-between py-4 transition-all [&[data-state=open]>svg]:rotate-[-90deg] text-lg font-normal hover:no-underline hover:text-primary">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground pb-4">{faq.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};
